import React from 'react';
import { useClassName } from '../hooks';
import './Frame.scss';

type FrameProps = {
  children?: React.ReactNode;
  className?: string;
};

const Frame: React.FC<React.PropsWithChildren<FrameProps>> = ({
  children,
  className
}) => {
  const cx = useClassName('tk-frame', className);

  return <div className={cx}>{children}</div>;
};

export default Frame;
